<template>
  <div class="page">
    <div class="card pb20">
      <p class="f16 mb10">{{ $t('product.importFile') }}</p>
      <div class="upload-container">
        <div class="upload-btn">
          <el-button type="primary" icon="el-icon-upload" plain>{{ $t('product.uploadFile') }}</el-button>
          <input @change="changeFile" accept=".xls,.xlsx" type="file" />
        </div>
        <el-button type="text" @click="downloadTemplate">{{ $t('common.download', ['']) }}{{ $t('common.template') }}</el-button>
      </div>
      <p class="mt10 gray">{{ $t('product.supportSuffix', ['.xls, .xlsx']) }}</p>
      <div class="file-item bg-gray" v-if="selectFileName"><i class="el-icon-document"></i> {{ selectFileName }}</div>
      <div class="mt20">
        <el-button type="primary" @click="submitUpload">{{ $t('product.importSupplyPrice') }}</el-button>
      </div>
    </div>

    <el-table class="spacing-table" v-loading="loading" :data="tableData">
      <el-table-column prop="createdAt" :label="$t('common.startDate')" min-width="150"></el-table-column>
      <el-table-column :label="$t('common.status')">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0">{{ $t('common.processing') }}</span>
          <span class="green" v-if="scope.row.status === 1">{{ $t('common.success') }}</span>
          <span class="green" v-if="scope.row.status === 2">{{ $t('common.fail') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="fileReport" :label="$t('product.fileReport')" min-width="200"></el-table-column>
      <el-table-column :label="$t('common.result')" min-width="150">
        <template slot-scope="scope">
          <template v-if="scope.row.data.total != undefined"> total {{ scope.row.data.total }}, </template>
          <template v-if="scope.row.data.total != undefined && scope.row.data.failedCount != undefined">
            success: {{ scope.row.data.total - scope.row.data.failedCount }},
          </template>
          <template v-if="scope.row.data.failedCount != undefined"> Faild: {{ scope.row.data.failedCount }} </template>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.wasteTime')" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.costTime != null ? scope.row.costTime / 1000 + $t('common.s') : '' }}
        </template>
      </el-table-column>
      <el-table-column width="250" :label="$t('common.action')">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            v-if="scope.row.status !== 0 && scope.row.data.importUrl"
            @click="downloadResult(scope.row.data.importUrl)"
            >Import File</el-button
          >
          <el-button
            type="primary"
            size="small"
            v-if="scope.row.status !== 0 && scope.row.data.resultUrl"
            @click="downloadResult(scope.row.data.resultUrl)"
            >{{ $t('common.download', [' ']) }}{{ $t('common.result') }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNum"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import OSS from 'ali-oss';
import { getImportSupplyPriceList, checkImportSupplyPrice, uploadImportSupplyPrice } from '../../api/product';
import { getOSSConfig, uploadImg } from '../../api/logistics';
import { downloadUrlFile } from '../../common/utils';

export default {
  name: 'ProductImport',
  data() {
    return {
      loading: false,
      queryForm: {
        pageNum: 1,
        pageSize: 25,
      },
      total: 0,
      tableData: [],
      selectFileName: '',
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNum = 1;
      this.getTableData();
    },
    reset() {
      this.daterange = [];
      this.queryForm.pageNum = 1;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      getImportSupplyPriceList(this.queryForm).then((res) => {
        this.total = res.data.total || 0;
        this.tableData = (res.data.list || []).map((item) => {
          try {
            item.data = JSON.parse(item.data);
            item.fileReport = item.data.fileReport;
          } catch (error) {
            // nothing
          }
          return item;
        });
        this.loading = false;
      });
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNum) {
      this.queryForm.pageNum = pageNum;
      this.getTableData();
    },
    downloadResult(url) {
      downloadUrlFile(url);
    },
    changeFile(e) {
      if (e && e.target && e.target.files && e.target.files[0]) {
        const file = e.target.files[0];
        if (!/\.xlsx?$/.test(String(file.name).toLowerCase())) {
          this.$message.error(this.$t('product.supportSuffix', ['.xls, .xlsx']));
        } else if (file.size > 50 * 1024 * 1024) {
          this.$message.error(this.$t('product.fileTooLarge'));
        } else {
          this.selectFileName = file.name;
          this.selectFile = file;
        }
      }
      e.target.value = '';
    },
    async submitUpload() {
      const checkRes = await checkImportSupplyPrice();
      if (!checkRes.success) {
        this.$message(this.$t('product.importingLater'));
        return;
      }
      if (!this.selectFile) {
        this.$message(this.$t('common.plzSelectFile'));
        return;
      }
      const fd = new FormData();
      fd.append('file', this.selectFile);
      fd.append('directoryPath', 'tmp');
      const uploadRes = await uploadImg(fd);
      const fileUrl = uploadRes.data.ossUrl;
      uploadImportSupplyPrice({
        fileUrl,
      }).then((res) => {
        if (res.success) {
          // nothing
        } else {
          this.$message.error(res.message);
        }
        this.selectFileName = '';
        this.selectFile = null;
        this.getTableData();
      });
    },
    downloadTemplate() {
      this.downloadResult('https://product-sts.oss-cn-shanghai.aliyuncs.com/tmp/base_price_template.xlsx');
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-container {
  display: flex;

  .upload-btn {
    position: relative;
    margin-right: 50px;

    input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
}
.file-item {
  display: inline-block;
  padding: 5px 10px;
  margin-top: 10px;
  border-radius: 4px;
}
</style>
